import React from 'react';
import { Icon, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { formatDistanceToNow } from 'date-fns';
import './SaveIndicator.css';

interface SaveIndicatorProps {
  saveState: 'idle' | 'dirty' | 'saving' | 'saved' | 'error';
  lastSaved?: number;
  error?: string | null;
}

/**
 * Save Indicator Component
 * Shows the current save state of a document
 */
export const SaveIndicator: React.FC<SaveIndicatorProps> = ({
  saveState,
  lastSaved,
  error,
}) => {
  const renderIndicator = () => {
    switch (saveState) {
      case 'saving':
        return (
          <div className="save-indicator saving">
            <Spinner size={14} />
            <span>Saving...</span>
          </div>
        );
      
      case 'saved':
        return (
          <div className="save-indicator saved">
            <Icon icon={IconNames.TICK_CIRCLE} size={14} />
            <span>
              Saved {lastSaved ? formatDistanceToNow(lastSaved, { addSuffix: true }) : ''}
            </span>
          </div>
        );
      
      case 'error':
        return (
          <div className="save-indicator error">
            <Icon icon={IconNames.ERROR} size={14} />
            <span>{error || 'Save failed'}</span>
          </div>
        );
      
      case 'dirty':
        return (
          <div className="save-indicator dirty">
            <Icon icon={IconNames.DOT} size={14} />
            <span>Unsaved changes</span>
          </div>
        );
      
      default:
        return null;
    }
  };

  return renderIndicator();
};





